module.exports = __webpack_public_path__ + "img/banner.28fb3861.svg";